import { useQuery } from '@tanstack/react-query';
import { useListFilters } from '@/shared/lib/useListFilters';
import { QueryStatus } from '@/shared/ui/QueryStatus';
import {
  EMPTY_METRIKA_FILTERS,
  fetchChart,
  fetchMetrikaFilters,
  type MetrikaChartEndpoint,
} from './api';
import { MetrikaChart } from './MetrikaChart';
import { MetrikaFilterBar, type MetrikaFilterName } from './MetrikaFilterBar';

type Props = {
  title: string;
  endpoint: MetrikaChartEndpoint;
  /** Y axis caption. */
  yLabel: string;
  /** Filters shown besides the date range and period. */
  extraFilters?: MetrikaFilterName[];
};

/** Filters + line chart of one `/analytics/default/*` series. */
export const MetrikaChartSection = ({ title, endpoint, yLabel, extraFilters = [] }: Props) => {
  const { draft, applied, setField, submit, reset } = useListFilters(EMPTY_METRIKA_FILTERS);
  const options = useQuery({ queryKey: ['metrika-filters'], queryFn: fetchMetrikaFilters });
  const chart = useQuery({
    queryKey: ['metrika-chart', endpoint, applied],
    queryFn: () => fetchChart(endpoint, applied),
  });

  return (
    <div className="box">
      <div className="box-header with-border">
        <h3 className="box-title">{title}</h3>
      </div>
      <div className="box-body">
        <MetrikaFilterBar
          fields={[...extraFilters, 'dateStart', 'dateEnd', 'period']}
          options={options.data}
          values={draft}
          onChange={setField}
          onSubmit={submit}
          onReset={reset}
        />
        <QueryStatus isLoading={chart.isLoading} error={chart.error} errorText="Ошибка загрузки данных" />
        {chart.data && <MetrikaChart data={chart.data} label={yLabel} />}
      </div>
    </div>
  );
};
